import React from 'react';
import Button from '../../../../composants/Button/Button';

// ── Types ─────────────────────────────────────────────────────────────────────

export interface ValidationItem {
  label: string;
  ok: boolean | null;
  detail?: string;
}

// ── Props ─────────────────────────────────────────────────────────────────────

interface SectionSoumissionProps {
  isSoumise: boolean;
  estMandataire: boolean;
  validationItems: ValidationItem[];
  isDeposing: boolean;
  acceptConditions: boolean;
  onToggleAccept: () => void;
  onDeposer: () => void;
}

// ── Section "Révision + Soumission" ──────────────────────────────────────────

const SectionSoumission: React.FC<SectionSoumissionProps> = ({
  isSoumise,
  estMandataire,
  validationItems,
  isDeposing,
  acceptConditions,
  onToggleAccept,
  onDeposer,
}) => {
  if (isSoumise) {
    return (
      <>
        <div className="section-header">Statut de la candidature</div>
        <div className="section-content">
          <div className="soumission-badge-soumise">Candidature soumise avec succès</div>
        </div>
      </>
    );
  }

  if (!estMandataire) return null;

  const allOk = validationItems.every((item) => item.ok === true);
  const canDeposer = acceptConditions && allOk && !isDeposing;

  return (
    <>
      <div className="section-header">Soumettre la candidature</div>
      <div className="section-content soumission-section">

        {/* Checklist pré-soumission */}
        <div className="soumission-block">
          <p className="soumission-block-title">Conditions requises avant dépôt</p>
          <ul className="soumission-checklist">
            {validationItems.map((item) => (
              <li
                key={item.label}
                className={`soumission-check-item ${item.ok === null ? 'loading' : item.ok ? 'ok' : 'ko'}`}
              >
                <span className="soumission-check-icon">
                  {item.ok === null ? '…' : item.ok ? '✓' : '✗'}
                </span>
                <span className="soumission-check-label">{item.label}</span>
                {item.detail && (
                  <span className="soumission-check-detail">{item.detail}</span>
                )}
              </li>
            ))}
          </ul>
        </div>

        {/* Checkbox conditions */}
        <label className="soumission-conditions">
          <input
            type="checkbox"
            checked={acceptConditions}
            onChange={onToggleAccept}
            disabled={!allOk}
          />
          <span>
            Je certifie que les informations fournies sont exactes et complètes,
            et j'accepte les conditions de l'accord-cadre 2027.
          </span>
        </label>

        {/* Bouton dépôt */}
        <div
          className="section-footer-right"
          style={{ padding: 0, borderTop: '1px solid #e5e7eb', marginTop: '0.75rem' }}
        >
          <Button
            type="button"
            variant="primary"
            value={isDeposing ? 'Dépôt en cours…' : 'Soumettre définitivement'}
            disabled={!canDeposer}
            onClick={onDeposer}
          />
        </div>
      </div>
    </>
  );
};

export default SectionSoumission;
